import { Wrapper } from "./styles";
import { StatusBadgeProps } from "./types";

export const StatusBadge: React.FC<StatusBadgeProps> = ({
  keyId,
  className,
  icon,
  text,
}) => {
  return (
    <Wrapper key={keyId} className={className}>
      <span className="status-icon">{icon}</span>
      {text}
    </Wrapper>
  );
};
